<template>
  <div id="app"
    :class="themeClass"
  >
    <router-view></router-view>
  </div>
</template>

<script>
  const pendoScript = `
  (function (apiKey) {
        if (!apiKey) {
          return
        }
        (function (p, e, n, d, o) {
        var v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
        for (w = 0, x = v.length; w < x; ++w) (function (m) {
        o[m] = o[m] || function () {
        o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
        };
        })(v[w]);
        y = e.createElement(n);
        y.async = !0;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo')
      })(window.config.PENDO_API_KEY)
  `

  export default {
    name: 'app',

    computed: {
      themeClass () {
        return `theme${this.theme}`
      },
      theme () {
        return this.$store.state.theme
      },
      demo () {
        return this.$store.state.demo
      }
    },
    watch: {
      theme () {
        // We need to ensure that the theme class on the body updates if we change the theme.
        document.body.classList = []
        document.body.classList.add(this.themeClass)
      }
    },
    created () {
      // We need to add the theme class to the body element bewcause several of element ui's components attach
      // themselves as directly children of <body>.
      document.body.classList.add(this.themeClass)
    },
    mounted () {
      if (!this.user.isGdprCovered) {
        // Here we inject the pendo script
        const app = document.querySelector('#app')

        const newScriptTag = document.createElement('script')
        newScriptTag.type = 'text/javascript'

        const newScriptText = document.createTextNode(pendoScript)

        newScriptTag.appendChild(newScriptText)
        app.appendChild(newScriptTag)
      }

      const demo = window.localStorage.getItem('demo')
      if (demo === 'true') {
        this.$store.commit('setDemo', true)
      }

      this.$watch('demo', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          window.location.reload()
        }
      })
    }
  }
</script>

<style lang="less">
  @import './assets/less/common.less';

  #app {
    font-family: 'HelveticaNeue', Helvetica, Arial, 'FontAwesome', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: @text-color;
    min-height: 100vh;

    &themenormal {
      background-color: @background;
    }

    &.themedark {
      background-color: @theme-dark-background;
      color: @theme-dark-text-color;
    }
  }

  .flex-vertical-parent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* align items in Main Axis */
    align-items: stretch; /* align items in Cross Axis */
    align-content: stretch; /* Extra space in Cross Axis */
  }

  .flex-vertical-stretch {
    flex: 1;
  }

  a {
    color: @nativo-blue;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
